module.exports = __webpack_public_path__ + "static/fonts/iconfont.a63e7ac1.ttf";